import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from '../../LanguageContext';
import styles from './NarkisRec.module.css';

// Import all 44 testimonial images
import recommend1 from "../../images/ נרקיס המלצות 1.webp";
import recommend2 from "../../images/ נרקיס המלצות 2.webp";
import recommend3 from "../../images/ נרקיס המלצות 3.webp";
import recommend4 from "../../images/ נרקיס המלצות 4.webp";
import recommend5 from "../../images/ נרקיס המלצות 5.webp";
import recommend6 from "../../images/ נרקיס המלצות 6.webp";
import recommend7 from "../../images/ נרקיס המלצות 7.webp";
import recommend8 from "../../images/ נרקיס המלצות 8.webp";
import recommend9 from "../../images/ נרקיס המלצות 9.webp";
import recommend10 from "../../images/ נרקיס המלצות 10.webp";
import recommend11 from "../../images/ נרקיס המלצות 11.webp";
import recommend12 from "../../images/ נרקיס המלצות 12.webp";
import recommend13 from "../../images/ נרקיס המלצות 13.webp";
import recommend14 from "../../images/ נרקיס המלצות 14.webp";
import recommend15 from "../../images/ נרקיס המלצות 15.webp";
import recommend16 from "../../images/ נרקיס המלצות 16.webp";
import recommend17 from "../../images/ נרקיס המלצות 17.webp";
import recommend18 from "../../images/ נרקיס המלצות 18.webp";
import recommend19 from "../../images/ נרקיס המלצות 19.webp";
import recommend20 from "../../images/ נרקיס המלצות 20.webp";
import recommend21 from "../../images/ נרקיס המלצות 21.webp";
import recommend22 from "../../images/ נרקיס המלצות 22.webp";
import recommend23 from "../../images/ נרקיס המלצות 23.webp";
import recommend24 from "../../images/ נרקיס המלצות 24.webp";
import recommend25 from "../../images/ נרקיס המלצות 25.webp";
import recommend26 from "../../images/ נרקיס המלצות 26.webp";
import recommend27 from "../../images/ נרקיס המלצות 27.webp";
import recommend28 from "../../images/ נרקיס המלצות 28.webp";
import recommend29 from "../../images/ נרקיס המלצות 29.webp";
import recommend30 from "../../images/ נרקיס המלצות 30.webp";
import recommend31 from "../../images/ נרקיס המלצות 31.webp";
import recommend32 from "../../images/ נרקיס המלצות 32.webp";
import recommend33 from "../../images/ נרקיס המלצות 33.webp";
import recommend34 from "../../images/ נרקיס המלצות 34.webp";
import recommend35 from "../../images/ נרקיס המלצות 35.webp";
import recommend36 from "../../images/ נרקיס המלצות 36.webp";
import recommend37 from "../../images/ נרקיס המלצות 37.webp";
import recommend38 from "../../images/ נרקיס המלצות 38.webp";
import recommend39 from "../../images/ נרקיס המלצות 39.webp";
import recommend40 from "../../images/ נרקיס המלצות 40.webp";
import recommend41 from "../../images/ נרקיס המלצות 41.webp";
import recommend42 from "../../images/ נרקיס המלצות 42.webp";
import recommend43 from "../../images/ נרקיס המלצות 43.webp";
import recommend44 from "../../images/ נרקיס המלצות 44.webp";

const testimonialImages = [
  recommend1, recommend2, recommend3, recommend4, recommend5,
  recommend6, recommend7, recommend8, recommend9, recommend10,
  recommend11, recommend12, recommend13, recommend14, recommend15,
  recommend16, recommend17, recommend18, recommend19, recommend20,
  recommend21, recommend22, recommend23, recommend24, recommend25,
  recommend26, recommend27, recommend28, recommend29, recommend30,
  recommend31, recommend32, recommend33, recommend34, recommend35,
  recommend36, recommend37, recommend38, recommend39, recommend40,
  recommend41, recommend42, recommend43, recommend44
];

// Single Testimonial Card Component
const TestimonialCard = ({ image, index, altPrefix }) => {
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1, rootMargin: '50px' }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <article
      ref={cardRef}
      className={`${styles.testimonialCard} ${isVisible ? styles.visible : ''}`}
      style={{ animationDelay: `${(index % 6) * 0.1}s` }}
    >
      <div className={styles.cardInner}>
        {/* Image Container */}
        <div className={styles.imageContainer}>
          <img
            src={image}
            alt={`${altPrefix} ${index + 1}`}
            className={styles.testimonialImage}
            loading="lazy"
            draggable={false}
          />
        </div>
      </div>
    </article>
  );
};

// Main NarkisRec Component
const NarkisRec = () => {
  const { t, isEnglish } = useTranslation();
  const sectionRef = useRef(null);

  return (
    <section className={styles.narkisRecSection} ref={sectionRef}>
      {/* Background Decorations */}
      <div className={styles.bgDecoration}>
        <div className={styles.noiseOverlay}></div>
        <div className={styles.gradientOrb1}></div>
        <div className={styles.gradientOrb2}></div>
        <div className={styles.gridLines}></div>
        
        {/* Floating Particles */}
        <div className={styles.particles}>
          {[...Array(20)].map((_, i) => (
            <div key={i} className={styles.particle}></div>
          ))}
        </div>
      </div>

      {/* Section Header */}
      <header className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>{t.rec.title}</h2>
        <p className={styles.sectionSubtitle}>{t.rec.subtitle}</p>
      </header>

      {/* Main Content */}
      <div className={styles.mainContent}>
        {/* Testimonials Grid */}
        <div className={styles.testimonialsGrid}>
          {testimonialImages.map((image, index) => (
            <TestimonialCard
              key={index}
              image={image}
              index={index}
              altPrefix={t.rec.altPrefix}
            />
          ))}
        </div>
      </div>

      {/* Bottom CTA */}
      <div className={styles.ctaWrapper}>
        
        <a  href={`https://wa.me/972544998929?text=${isEnglish ? 'Hi%20Narkis%2C%20I%20came%20from%20your%20website%20and%20would%20love%20to%20hear%20more..' : 'היי%20נרקיס%20הגעתי%20מהדף%20שלך%20אשמח%20לשמוע%20עוד%20על..'}`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.ctaButton}>
          <span>{t.rec.ctaText}</span>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </a>
      </div>
    </section>
  );
};

export default NarkisRec;